import { render, staticRenderFns } from "./edit_rule.vue?vue&type=template&id=5ddd601a"
import script from "./edit_rule.vue?vue&type=script&lang=js"
export * from "./edit_rule.vue?vue&type=script&lang=js"
import style0 from "./edit_rule.vue?vue&type=style&index=0&id=5ddd601a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports